import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { fill, t, type JobChecklistAnswer } from '@bms2/shared';
import { PageModule } from '../../shell/PageModule';
import { JobChecklist } from './JobChecklist';
import styles from './JobChecklist.module.css';

/** 🔒 Decision 2111: the job's own Checklist page, which its Visits tile links to. */
export const jobChecklistRoute = (workOrderId: string): string => `/work-orders/${workOrderId}/checklist`;

/**
 * 🔒 The job's own Checklist page (piece 29; T889; decision 2111): every item on
 * the checklists tagged to the Work Order, answered and signed off here as on
 * the visit's page. It serves a job booked before visits existed, and the
 * office manager who signs off from the job rather than from a visit.
 */
export function JobChecklistPage({ workOrderId, apiBaseUrl = '' }: { workOrderId: string; apiBaseUrl?: string }) {
  const [read, setRead] = useState<JobChecklistAnswer | null>(null);
  const number = read?.workOrderNumber ?? '';
  return (
    <PageModule title={number ? fill(t('checklist.page.title'), { number }) : t('checklist.page.kind')} subtitle={t('checklist.page.kind')} icon="workOrder">
      <div className={styles.checklist} data-job-checklist-page={workOrderId}>
        <Link to={`/work-orders/${workOrderId}`} data-job-checklist-back={workOrderId}>{fill(t('checklist.page.backToJob'), { number: number || t('checklist.page.kind') })}</Link>
        <JobChecklist workOrderId={workOrderId} apiBaseUrl={apiBaseUrl} onRead={setRead} />
      </div>
    </PageModule>
  );
}

/** The route's own reading of the job, keyed so a second job's page never shows the first one's drafts. */
export function JobChecklistRoute({ apiBaseUrl = '' }: { apiBaseUrl?: string }) {
  const { id = '' } = useParams();
  return <JobChecklistPage key={id} workOrderId={id} apiBaseUrl={apiBaseUrl} />;
}
